import { escapeHTML } from 'cadenza/utils/escape-html';
import { mark } from 'cadenza/utils/mark/mark';

export function escapeAndMarkHTML (value: string | undefined, leadingP = true) {
  return mark(escapeHTML(value), leadingP);
}
